import { createContext,useContext } from "react";
import type { LocalSessionState,LocalTrackerSession } from "../local-session";
import type { ActivityPalette } from "../ActivityProfileModal";
import type { QsmartActions } from "./domain/types";
import { liveModel } from "./live-model";
export type Live = ReturnType<typeof liveModel>&{state:LocalSessionState;session:LocalTrackerSession;locale:"da-DK"|"en-GB";palette:ActivityPalette;actions:QsmartActions;routeDate?:string;onActivityDay:(date:string)=>void;onRouteDay:(date:string)=>void;onLanguage:()=>void;onTheme:()=>void;onLogout:()=>void};
export const LiveContext=createContext<Live|null>(null);
export function useLive(){const value=useContext(LiveContext);if(!value)throw new Error("Missing tracker context");return value;}
